export default __webpack_public_path__ + "static/media/visualization.bb0bafb2.png";